export function MemberPicker({ members, value = [], onChange, testid = "member-picker" }) {
  const toggle = (id) => {
    if (value.includes(id)) onChange(value.filter((x) => x !== id));
    else onChange([...value, id]);
  };
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={testid}>
      <button type="button" onClick={() => onChange([])} data-testid="member-chip-all"
        className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors ${value.length === 0 ? "bg-primary text-primary-foreground border-primary" : "bg-card border-border text-muted-foreground hover:border-primary"}`}>
        Toute la famille
      </button>
      {members.map((m) => {
        const active = value.includes(m.id);
        return (
          <button key={m.id} type="button" onClick={() => toggle(m.id)} data-testid={`member-chip-${m.id}`}
            className={`px-3 py-1 rounded-full text-xs font-medium border transition-colors flex items-center gap-1.5 ${active ? "text-white border-transparent" : "bg-card border-border text-muted-foreground hover:border-primary"}`}
            style={active ? { backgroundColor: m.color } : {}}>
            <span className="w-2 h-2 rounded-full" style={{ backgroundColor: active ? "#fff" : m.color }} />
            {m.name}
          </button>
        );
      })}
    </div>
  );
}

export function MemberChips({ members = [], ids = [] }) {
  if (!ids || ids.length === 0)
    return <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-secondary text-muted-foreground whitespace-nowrap">Toute la famille</span>;
  const map = Object.fromEntries(members.map((m) => [m.id, m]));
  return (
    <span className="inline-flex flex-wrap gap-1">
      {ids.map((id) => {
        const m = map[id];
        if (!m) return null;
        return <span key={id} className="text-[10px] px-1.5 py-0.5 rounded-full text-white whitespace-nowrap" style={{ backgroundColor: m.color }}>{m.name}</span>;
      })}
    </span>
  );
}
